<lcs-advanced-multi-select
   [headerText]="labelSignal()"
   [triggerConfig]="triggerConfig()"
   [datasources]="[datasource()]"
   [headerActionsTemplate]="headerActionsTemplate"
   [hasRestoreDefaults]="false"
   (save)="onSave($event)"
   (selectedItemsChange)="onSelectedItemsChange($event)"
   (search)="onSearch($event)"
   (close)="onCancel($event)"
   (openDialog)="onOpen($event)"
   #trigger
>
   <ng-template let-context advancedMultiSelectListItemDisplay>
      <lcs-advanced-multi-select-trigger [context]="context"> </lcs-advanced-multi-select-trigger>
   </ng-template>
   <ng-template #headerActionsTemplateRef let-context>
      <span class="copy-warning">This will copy the current exception to the selected schedules.</span>
   </ng-template></lcs-advanced-multi-select
>
